/** 指挥页队员树桌面 / 手机主题样式 */
const THEMES = {
  desktop: {
    root: { fontSize: 14 },
    orgWrap: { marginBottom: 8 },
    orgHeader: {
      padding: '8px 10px',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      background: '#f3f6f9',
      border: '1px solid #e6edf2',
      borderRadius: 6,
      marginBottom: 4
    },
    orgTitle: { fontWeight: 600, color: '#333' },
    orgChevron: { color: '#1976d2', fontSize: 16, fontWeight: 600 },
    orgChevronSide: 'left',
    groupsWrap: { marginLeft: 20, marginBottom: 8 },
    groupWrap: { marginBottom: 4 },
    groupHeader: {
      padding: '4px 8px',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      background: '#f1f3f4',
      border: '1px solid #dadce0',
      borderRadius: 3,
      marginBottom: 2
    },
    groupTitle: { fontWeight: 500, color: '#555' },
    groupChevron: { color: '#1976d2', fontSize: 14, fontWeight: 500 },
    membersWrap: { marginLeft: 20 },
    memberWrap: { marginBottom: 2 },
    memberRow: (isExpanded) => ({
      padding: '6px 10px',
      cursor: 'pointer',
      background: isExpanded ? '#e8f1fb' : '#fff',
      border: '1px solid #e9ecef',
      borderRadius: 6,
      display: 'flex',
      alignItems: 'center',
      gap: 8,
      minWidth: 0,
      overflow: 'hidden'
    }),
    orgBtn: { height: 20, lineHeight: '20px', padding: '0 6px', fontSize: 11, borderRadius: 3 },
    groupBtn: { height: 18, lineHeight: '18px', padding: '0 4px', fontSize: 10, borderRadius: 2 }
  },
  mobile: {
    root: { flex: 1, fontSize: 12 },
    orgWrap: {},
    orgHeader: {
      background: '#1976d2',
      color: '#fff',
      padding: '6px 8px',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      fontSize: 13,
      fontWeight: 600
    },
    orgTitle: {},
    orgChevron: {},
    orgChevronSide: 'right',
    groupsWrap: {},
    groupWrap: {},
    groupHeader: {
      background: '#e3f2fd',
      padding: '4px 8px',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      borderBottom: '1px solid #ccc',
      fontSize: 12,
      fontWeight: 500
    },
    groupTitle: {},
    groupChevron: {},
    membersWrap: {},
    memberWrap: { borderBottom: '1px solid #eee' },
    memberRow: (isExpanded) => ({
      padding: '6px 8px',
      cursor: 'pointer',
      background: isExpanded ? '#f5f5f5' : '#fff',
      display: 'flex',
      alignItems: 'center',
      gap: 6,
      minWidth: 0,
      overflow: 'hidden'
    }),
    orgBtn: { height: 18, lineHeight: '18px', padding: '0 4px', fontSize: 10, borderRadius: 2 },
    groupBtn: { height: 16, lineHeight: '16px', padding: '0 3px', fontSize: 9, borderRadius: 2 }
  }
};

export default THEMES;
